/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIsNarrow } from '@/shared/hooks/useMediaQuery';
import storage from '@/shared/utils/storage';

const STORAGE_KEY = 'boxedViewEnabled';

const BoxedViewContext = createContext({
   boxedView: false,
   setBoxedView: () => {},
   effectiveBoxed: false,
   isNarrow: false,
});

export function BoxedViewProvider({ children }) {
   const [boxedView, setBoxedView] = useState(() => {
      try {
         const stored = storage.getItem(STORAGE_KEY);
         return stored === null ? false : stored === 'true' || stored === true;
      } catch {
         return false; // safe fallback if storage is unavailable
      }
   });

   useEffect(() => {
      try {
         storage.setItem(STORAGE_KEY, boxedView);
      } catch {
         // ignore
      }
   }, [boxedView]);

   const isNarrow = useIsNarrow();
   const effectiveBoxed = !isNarrow && boxedView;

   const value = useMemo(
      () => ({ boxedView, setBoxedView, effectiveBoxed, isNarrow }),
      [boxedView, effectiveBoxed, isNarrow],
   );

   return <BoxedViewContext.Provider value={value}>{children}</BoxedViewContext.Provider>;
}

BoxedViewProvider.propTypes = {
   children: PropTypes.node.isRequired,
};

export function useBoxedView() {
   return useContext(BoxedViewContext);
}
